<div class="page">
  <div class="box">
    <div class="headerbox">
      <div class="title">
        <i
          *ngIf="itemService.order.currentInformation?.OrderServices && itemService.order?.saleMethodBranch?.HasDeposit"
          class="icon icon-cash-multiple"
          (click)="depositShowHide()"
          [tooltip]="'ClientApp.FrontOffice.Order.OrderPage.Item.Desktop.OrderService' | translate"></i>
      </div>
      <i class="icon icon-view_module-f" [class.icon-apps]="changeView" (click)="changeCategoryView()"></i>
    </div>
    <ng-container *ngIf="itemService.order.isShowDeposit; else orderItem">
      <order-deposit class="order-deposit"></order-deposit>
    </ng-container>
    <ng-template #orderItem>
      <div class="itemcategorybox" #container [style.width.px]="data.width" [style.height.px]="data.height">
        <div class="list-item-category-box" [ngClass]="[changeCatView ? 'cat-with-img' : '']">
          <ng-container *ngIf="!itemService.order.itemCategoryList">
            <div *ngFor="let _ of [].constructor(8)" data-skeleton style="--skeleton-lines: 1"></div>
          </ng-container>
          <div *ngFor="let itemCategory of itemService.order.itemCategoryList">
            <div
              *ngIf="itemCategory?.Id != 0; else others"
              class="listcategory"
              [contextMenuTrigger]="menu"
              [menuContext]="{
                value: itemCategory,
                enum: contextmenuEnum.Category,
                visible: itemService.order.isMultiBranch,
                order: itemService.order
              }"
              (menuAction)="($event)"
              [ngClass]="{
                unavailable: itemCategory.categoryPopupState == popUpState.AllNonAvailable,
                'with-img': changeCatView
              }"
              (click)="itemService.changeItemCategory(itemCategory); updateArray()"
              [class.active]="itemCategory?.Id === itemService.order.selectedItemCategory?.Id">
              <i [class.visible]="itemCategory?.Id === itemService.order.selectedItemCategory?.Id" class="icon icon-circle1"></i>
              <img *ngIf="changeCatView" [src]="itemCategory.Image ?? 'assets/images/place-holder.svg'" />
              {{ itemCategory.Title }}
            </div>
            <ng-template #others>
              <div
                class="listcategory"
                [ngClass]="[changeCatView ? 'with-img' : '']"
                (click)="itemService.changeItemCategory(itemCategory); updateArray()"
                [class.active]="itemCategory?.Id === itemService.order.selectedItemCategory?.Id">
                <i [class.visible]="itemCategory?.Id === itemService.order.selectedItemCategory?.Id" class="icon icon-circle1"></i>
                <img *ngIf="changeCatView" src="assets/images/place-holder.svg" />
                {{ itemCategory.Title }}
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div
        class="resize resize__bottom"
        (resize)="Resize($event)"
        (resizeEnd)="resizeEnd($event)"
        [targetElement]="container"
        [direction]="AngularResizeElementDirection.BOTTOM"></div>
      <div class="groupbox">
        <div class="grupname">
          {{ itemService.order.selectedItemCategory.Title }}
        </div>
      </div>
      <div class="item-detail">
        <div class="d-flex align-items-center">
          <div class="itemfilterbox" *ngIf="itemService.order?.saleMethodBranch?.HasKeyboardOrder">
            <ssg-input
              (onEnter)="itemService.findItem($event)"
              (focusout)="itemService.findItem($event)"
              id="Code{{ itemService.order.__id }}"
              [group]="itemService.order.formGroup"
              name="Code{{ itemService.order.__id }}"
              textType="text"
              [label]="'ClientApp.FrontOffice.Order.OrderPage.Item.Desktop.Code' | translate"
              class="code"
              borderColor="test">
            </ssg-input>
            <ssg-input
              (valueChange)="itemService.findItemByName($event)"
              class="name"
              [group]="itemService.order.formGroup"
              name="ItemTitle{{ itemService.order.__id }}"
              textType="text"
              hasClear="true"
              [max]="250"
              (clear)="itemService.findItemByName(null)"
              [label]="'ClientApp.FrontOffice.Order.OrderPage.Item.Desktop.ItemTitle' | translate">
            </ssg-input>
            <ssg-input
              class="code"
              (onEnter)="itemService.setQuantity($event)"
              [group]="itemService.order.formGroup"
              [maxLength]="10"
              name="Quantity{{ itemService.order.__id }}"
              textType="number"
              [label]="'ClientApp.FrontOffice.Order.OrderPage.Item.Desktop.Counter' | translate">
            </ssg-input>
          </div>
          <i class="icon icon-view_module-f" [class.icon-apps]="changeView" (click)="changeItemView()"></i>
        </div>
        <div class="detail" [ngClass]="[itemService.order?.saleMethodBranch?.HasKeyboardOrder ? 'detail-height' : '']">
          <ng-container *ngIf="!itemService.order.itemCategoryList">
            <div class="items-skelecton">
              <div *ngFor="let _ of [].constructor(30)" data-skeleton style="--skeleton-lines: 1"></div>
            </div>
          </ng-container>

          <ng-container *ngIf="!itemService.order.itemHasParent">
            <cdk-virtual-scroll-viewport
              itemSize="2"
              minBufferPx="200"
              maxBufferPx="400"
              cdkVirtualForTemplateCacheSize="50"
              [class.itemsizeonopenDescription]="itemService.order.OrderSetting.IsShowDescriptionBox"
              [class.minsize]="changeView">
              <div
                class="listitem"
                [ngClass]="[item.StockInWeb && item.ItemChild === null ? (item.StockInWeb == 1 ? 'unavailable' : 'inv-unavailable') : '']"
                *cdkVirtualFor="let item of itemService.order.selectedItemCategory.Items"
                [contextMenuTrigger]="menu"
                [menuContext]="{
                  value: item,
                  enum: contextmenuEnum.Item,
                  visible: itemService.order.isMultiBranch || item.ItemChild?.length,
                  order: itemService.order
                }"
                (menuAction)="($event)">
                <span
                  *ngIf="item.ItemChild == null && itemService.order.canSeeFavorites"
                  (click)="checkfavorite(item)"
                  class="star"
                  [ngClass]="item.favoriteIndex >= 0 ? 'd-inline-flex' : ''">
                  <i [ngClass]="item.favoriteIndex >= 0 ? 'icon-starradius-f' : 'icon-starradius-o'" class="staricon"></i>
                </span>
                <ng-container *ngIf="item.Ingredients; else withoutTooltip">
                  <div class="itemcontent" (click)="itemService.setSelectedItem(item)" [tooltip]="item.Ingredients">
                    <div class="nameitem">{{ item.Title }}</div>
                    <div class="price">
                      <span *ngIf="item.DetaultPrice !== 0" class="itemprice">{{ item.DetaultPrice | number }}</span>
                      <span *ngIf="item.DetaultPrice > 0" class="itemnumber">{{ item.Code }}</span>
                      <i *ngIf="item.Code === 0" class="icon-content-copy"></i>
                    </div>
                  </div>
                </ng-container>

                <ng-template #withoutTooltip>
                  <div class="itemcontent" (click)="itemService.setSelectedItem(item)">
                    <div class="nameitem">{{ item.Title }}</div>
                    <div class="price">
                      <span *ngIf="item.DetaultPrice !== 0" class="itemprice">{{ item.DetaultPrice | number }}</span>
                      <span *ngIf="item.DetaultPrice > 0" class="itemnumber">{{ item.Code }}</span>
                      <i *ngIf="item.Code === 0" class="icon-content-copy"></i>
                    </div>
                  </div>
                </ng-template>

                <div class="numitem" *ngIf="item?.InvoiceQty && item.Code !== 0">
                  <i
                    class="icon-add_circle_outline-o"
                    *ngIf="item.InvoiceQty > 0 && itemService.common.isMobileMode"
                    (click)="itemService.changeInvoiceQuantity(item, itemService.invoiceservice.itemStateEnum.Increase)">
                  </i>
                  <span class="num" *ngIf="item.InvoiceQty > 0 && itemService.common.isMobileMode">{{ item.InvoiceQty }}</span>
                  <i
                    class="icon-remove_circle_outline-o"
                    *ngIf="item.InvoiceQty > 0 && itemService.common.isMobileMode"
                    (click)="itemService.changeInvoiceQuantity(item, itemService.invoiceservice.itemStateEnum.Decrease)">
                  </i>
                </div>
              </div>
            </cdk-virtual-scroll-viewport>
          </ng-container>

          <div class="bundel-box">
            <cdk-virtual-scroll-viewport
              *ngIf="itemService.order.itemHasParent"
              itemSize="2"
              minBufferPx="200"
              maxBufferPx="400"
              cdkVirtualForTemplateCacheSize="50"
              [class.minsize]="changeView">
              <div class="bunddle" (click)="backOfBundle()">
                <i class="icon-keyboard_return-o backicon"></i>
              </div>
              <div
                class="listitem"
                *cdkVirtualFor="let item of itemService.order.itemHasParent"
                [ngClass]="[item.StockInWeb && item.ItemChild === null ? (item.StockInWeb == 1 ? 'unavailable' : 'inv-unavailable') : '']"
                [contextMenuTrigger]="menu"
                [menuContext]="{ value: item, enum: contextmenuEnum.Item, visible: itemService.order.isMultiBranch, order: itemService.order }"
                (menuAction)="($event)">
                <span
                  *ngIf="item.ItemChild == null && itemService.order.canSeeFavorites"
                  (click)="checkfavorite(item)"
                  class="star"
                  [ngClass]="item.favoriteIndex >= 0 ? 'd-inline-flex' : ''">
                  <i [ngClass]="item.favoriteIndex >= 0 ? 'icon-starradius-f' : 'icon-starradius-o'" class="staricon"></i>
                </span>
                <ng-container *ngIf="item.Ingredients; else withoutTooltip2">
                  <div class="itemcontent" [tooltip]="item.Ingredients" (click)="itemService.setSelectedItem(item)">
                    <div class="nameitem">{{ item.Title }}</div>
                    <div class="price">
                      <span class="itemprice">
                        {{ item.DetaultPrice | number }}
                      </span>
                      <span class="itemnumber">{{ item.Code }}</span>
                    </div>
                  </div>
                </ng-container>

                <ng-template #withoutTooltip2>
                  <div class="itemcontent" (click)="itemService.setSelectedItem(item)">
                    <div class="nameitem">{{ item.Title }}</div>
                    <div class="price">
                      <span class="itemprice">
                        {{ item.DetaultPrice | number }}
                      </span>
                      <span class="itemnumber">{{ item.Code }}</span>
                    </div>
                  </div>
                </ng-template>

                <div class="numitem" *ngIf="item?.InvoiceQty && itemService.common.isMobileMode">
                  <i class="icon-add_circle_outline-o" *ngIf="item.InvoiceQty > 0" (click)="itemService.setSelectedItem(item)"> </i>
                  <span class="num" *ngIf="item.InvoiceQty > 0">
                    {{ item.InvoiceQty }}
                  </span>
                  <i
                    class="icon-remove_circle_outline-o"
                    *ngIf="item.InvoiceQty > 0"
                    (click)="itemService.changeInvoiceQuantity(item, itemService.invoiceservice.itemStateEnum.Decrease)">
                  </i>
                </div>
              </div>
            </cdk-virtual-scroll-viewport>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
  <!-- توضیحات -->
  <div class="descriptionbox">
    <order-description></order-description>
  </div>
</div>
